import * as yup from "yup";

export const MAX_NUM_CHARACTERS_PER_FIELD_LABEL = 300; // characters here means text, not fictional entities

// Truncate rather than reject: oversized labels can reach the DB through paths that
// bypass the entity schemas (AI tools, imports), and rejecting makes the entity
// unsavable — every subsequent editor save fails validation.
export const CustomFieldLabelSchema = yup
  .string()
  .transform((value) => (typeof value === "string" ? value.slice(0, MAX_NUM_CHARACTERS_PER_FIELD_LABEL) : value))
  .max(MAX_NUM_CHARACTERS_PER_FIELD_LABEL)
  .default("");
